import React from 'react'
import {Icon} from '@chakra-ui/react'

const RightIcon = (props) => {
    return (
        <Icon viewBox="0 0 40 40" {...props}>
            <path
                id="arrow"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M39.9457 20.9886C39.98 20.9014 40 20.81 40 20.7143C40 20.6186 39.98 20.5257 39.9457 20.4386C39.91 20.3529 39.8571 20.2743 39.7914 20.2086L26.2057 6.63715C25.9271 6.35858 25.4743 6.35858 25.1957 6.63715C24.9157 6.91572 24.9157 7.36858 25.1957 7.64715L37.5614 20H0.714286C0.32 20 0 20.3186 0 20.7143C0 21.1086 0.32 21.4286 0.714286 21.4286H37.5614L25.1957 33.78C24.9157 34.0586 24.9157 34.5114 25.1957 34.79C25.3343 34.93 25.5171 35 25.7 35C25.8829 35 26.0657 34.93 26.2057 34.79L39.7914 21.22C39.8571 21.1543 39.91 21.0772 39.9457 20.9886Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default RightIcon
